import { ethers } from 'ethers'
import { useCallback, useEffect, useState } from 'react'
import { hooks } from '../metamask';
import ABI from './ABI.json'
const {
  useAccount, useProvider,
} = hooks;
export const useAirdropVerify = () => {
  const provider = useProvider()
  const address = useAccount()
  const [contract, setContract] = useState('')
  useEffect(() => {
    if (!!provider && !!address) {
      const airdropVerify = new ethers.Contract(
        process.env.REACT_APP_AIRDROP_VERIFY_ADDRESS,
        ABI,
      ).connect(provider.getSigner())
      setContract(airdropVerify)
    }

  }, [provider, address])
  const getIsVerified = async () => {
    const isUsed = await contract.hashUsed(address);
    const isLedgered = await contract.balance(address);
    return isUsed || isLedgered
  }

  const getAirdrop = useCallback(async (message, v, r, s) => {
    const tx = await contract.getAirdrop(message, v, r, s)
    await tx.wait();
  }, [contract])
  return {
    getAirdrop,
    getIsVerified
  }
}